import type { ConditionCategory, ConditionType } from "@sinch/types/sinch.types";
import { sortLocalized } from "@sinch/utils/array";
import type { RateConditionSubjectFragment } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/ConditionInput/queries.types";

export const getValLabel = (
  category: ConditionCategory,
  type: ConditionType | null,
  subjectId: string | null,
  label: string,
  group?: string
) => ({
  value: {
    category: category,
    subjectId: subjectId,
    type: type,
  },
  group,
  label: label,
});
export const getSubjectLabels = (
  category: ConditionCategory,
  subjects: ({ __typename?: "RateConditionSubject" } & RateConditionSubjectFragment)[] | undefined
) =>
  subjects?.map(({ type, subjectId, label: subjectLabel, group }) =>
    getValLabel(category, type, subjectId ?? null, subjectLabel, group ?? undefined)
  ) ?? [];
export const sortSubject = (
  rateConditionOptions: {
    value: {
      category: ConditionCategory;
      subjectId: string | null;
      type: ConditionType | null;
    };
    group: string | undefined;
    label: string;
  }[],
  locale: string
) =>
  sortLocalized(rateConditionOptions, ({ group, label: subjectLabel }) => [group, subjectLabel].join("/"), locale) ??
  [];
